import GoalReview from './GoalReview';

export default GoalReview;
